import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService } from 'gw-portals-document-js';
import { DocumentDownloadService } from 'adac-portals-document-js';

export default class ClaimService {
    static getClaimSummaries(query, offset, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'getClaimSummaries',
            [query, offset],
            additionalHeaders
        );
    }

    static getClaimDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'getClaimDetail',
            [claimNumber],
            additionalHeaders
        );
    }

    static getClaimPolicyDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'getClaimPolicyDetail',
            [claimNumber],
            additionalHeaders
        );
    }

    static getClaimActivities(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'getClaimActivities',
            [claimNumber],
            additionalHeaders
        );
    }

    static getClaimNotes(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'getClaimNotes',
            [claimNumber],
            additionalHeaders
        );
    }

    static createClaimNote(claimNumber, noteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'createClaimNote',
            [claimNumber, noteDTO],
            additionalHeaders
        );
    }

    static signAndStoreEbs(token, ebsDto, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'signAndStoreEbs',
            [token, ebsDto],
            additionalHeaders
            );
    }

    static hasEbsSigned(token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'hasEbsSigned',
            [token, sessionUUID],
            additionalHeaders
            );
    }

    static getPatientData(token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'getPatientData',
            [token, sessionUUID],
            additionalHeaders
            );
    }

    static handleRecall(recallDto, token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'handleRecall',
            [recallDto, token, sessionUUID],
            additionalHeaders
            );
    }

    static hasOpenRecallActivity(token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'hasOpenRecallActivity',
            [token, sessionUUID],
            additionalHeaders
            );
    }

    static retrieveNotesHistory(token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'retrieveNotesHistory',
            [token, sessionUUID],
            additionalHeaders
            );
    }

    static getClaimDocuments(token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'getClaimDocuments',
            [token, sessionUUID],
            additionalHeaders
            );
    }

    static updateClaimNote(claimNumber, note, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'updateClaimNote',
            [claimNumber, note],
            additionalHeaders
            );
    }

    static deleteClaimNote(claimId, noteId, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
            'deleteClaimNote',
            [claimId, noteId],
            additionalHeaders
            );
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(
        	getProxiedServiceUrl('claimDocumentUpload'),
            file,
            documentMetadata,
            additionalHeaders
            );
    }

    static claimsDocUploadToken(token, sessionUUID, params, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claimDocs'),
            'generateUploadToken',
            [token, sessionUUID],
            params,
            additionalHeaders
            );
    }

    static claimsRemoveDocument(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'removeDocument',
            params, additionalHeaders);
    }

    static getCommunicationTypeAndSession(token, claimAuthorizationDto, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
        	'getCommunicationTypeAndSession',
        	[token, claimAuthorizationDto],
        	additionalHeaders
        	);
    }

    static getPortalMessage(token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
        	'getPortalMessage',
        	[token, sessionUUID],
        	additionalHeaders
        	);
    }

    static sendNote(noteDto, recallDto, token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
        	'sendNote',
        	[noteDto, recallDto, token, sessionUUID],
        	additionalHeaders
        	);
    }

    static getClaimDocument(token, sessionUUID) {
        const url = DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('hermesDownloadDocument'), token, sessionUUID);
        return DocumentDownloadService.getDocument(url);
    }

    static getDocumentTemplate(token, sessionUUID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'getDocumentTemplate',
            [token, sessionUUID],
            additionalHeaders
        );
    }

    static signAndStoreDocument(token, formData, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'signAndStoreDocument',
            [token, formData],
            additionalHeaders
        );
    }

    static retrieveCommunicationHistory(token, formData, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('claim'),
            'retrieveCommunicationHistory',
            [token, formData],
            additionalHeaders
        );
    }

    static validateToken(token) {
        return JsonRPCService.send(
        	getProxiedServiceUrl('claim'),
        	'validateToken',
        	[token]
        );
    }
}
